import React   from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types'

const ProjectSummaryItem = ({
  code, name, total, unitPrice, leadTime, onDelete,index
}) => (
  <div className={`col-xs-4 col-sm-4 col-md-3 col-lg-2 cart-item ${index==0?'style-section-pcb':''}`} id={`box-cart-item-${code}`}>
    <div className={`cart-item-${code}`}>
      <div className="title">
        {name}
      </div>
      <div className="cart-content">
        <div className="total-price">
          ${numeral(total).format('0.00')}
        </div>
        <div className="unit-price">
          (<span className="unit-price"> ${numeral(unitPrice).format('0.00')} </span> per
          board )
        </div>
        <div className="leadtime">
          <span className="label">Lead Time </span>
          <span className="value">{leadTime} days</span>
        </div>
      </div>
    </div>
  </div>
)

ProjectSummaryItem.propTypes = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  unitPrice: PropTypes.number.isRequired,
  leadTime: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default ProjectSummaryItem;
